/* eslint-disable no-nested-ternary */
/* eslint-disable no-prototype-builtins */
import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import app from 'general/js/app';
import { SSOFormContext } from './sso-form-context';
import { ssoFormTypes } from './utils/form-types';
import eventBus from '../../../general/js/event-bus';
import { ssoFormConstants } from './sso-form-constants';
import { domainConstants } from './utils/constants/domain-constants';
import userService from '../../../general/js/user/user-service';
import { formConstants } from './utils/constants/form-constants';
import { getProperty, hasValue } from '../../../general/js/general-helpers';
import { sitecoreFieldConstants } from '../../sitecore-fields/js/sitecore-field-constants';
import { isBallotForm } from './forms/helpers/form-helpers/form-field-helpers';
import { redirectTo, reloadPageWithoutQueryParams } from '../../../general/js/utils';

class SSOForm extends React.Component {
    constructor(props) {
        super(props);

        this.ssoContext = {
            currentScenarioTitle: 'SSO Forms',
            cognitoUser: {}
        };
        const { IsPopup, formType, registerFormType } = this.props.formData;

        this.state = {
            ssoFormType: formType,
            initialFormType: formType,
            isFormDataDirty: false,
            registerFormType,
            IsPopup,
            modalOpen: true
        };

        this.displaySSOForm = this.displaySSOForm.bind(this);
        this.handleSignIn = this.handleSignIn.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleNewPasswordRequired = this.handleNewPasswordRequired.bind(this);
        this.handleUserRegisterSuccess = this.handleUserRegisterSuccess.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.handleBallotForgotPassword = this.handleBallotForgotPassword.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.onModalOpen = this.onModalOpen.bind(this);
        this.getTransitionToForm = this.getTransitionToForm.bind(this);
        this.handleBallotSignIn = this.handleBallotSignIn.bind(this);
        this.handleBallotRegister = this.handleBallotRegister.bind(this);
        this.handleCognitoHostedUISignIn = this.handleCognitoHostedUISignIn.bind(this);
        this.handleSignInSucces = this.handleSignInSucces.bind(this);
        this.handleBallotSummarySuccess = this.handleBallotSummarySuccess.bind(this);
        this.handleBallotPortalRedirect = this.handleBallotPortalRedirect.bind(this);

        eventBus.addListener('modal:closed', this.onModalClose);
        eventBus.addListener('modal:open', this.onModalOpen);
    }

    onModalClose() {
        const { IsPopup } = this.props;

        sessionStorage.removeItem(formConstants.ballotSignInStorageItem);

        if (!IsPopup) {
            return;
        }
        this.setState((state) => ({
            ...state,
            modalOpen: false,
            ssoFormType: state.initialFormType
        }));
    }

    onModalOpen() {
        const { IsPopup } = this.props;
        if (!IsPopup) {
            return;
        }

        this.setState((state) => ({
            ...state,
            modalOpen: true
        }));
    }

    handleRegister() {
        const { initialFormType } = this.state;
        const transitionToForm = this.getTransitionToForm();

        this.setState((state) => ({
            ...state,
            ssoFormType: transitionToForm,
            isFormDataDirty: initialFormType !== transitionToForm
        }));
    }

    handleBallotRegister() {
        const { initialFormType } = this.state;
        const { formData } = this.props;
        const { nextFormTypeAfterRegister } = formData;

        this.setState((state) => ({
            ...state,
            ssoFormType: nextFormTypeAfterRegister,
            isFormDataDirty: initialFormType !== nextFormTypeAfterRegister
        }));
    }

    handleBallotSummarySuccess() {
        const { initialFormType } = this.state;
        const { formData: { nextFormTypeAfterSubmit, nextFormAfterSubmit } } = this.props;

        if (nextFormAfterSubmit === sitecoreFieldConstants.emptyGUID || !hasValue(nextFormAfterSubmit) || !hasValue(nextFormTypeAfterSubmit)) {
            this.handleBallotPortalRedirect();
            return;
        }

        const nextFormType = getProperty(ssoFormTypes, nextFormTypeAfterSubmit);

        if (!hasValue(nextFormType)) {
            this.handleBallotPortalRedirect();
            return;
        }

        const isFromBallot = isBallotForm(initialFormType);

        this.setState((state) => ({
            ...state,
            ssoFormType: nextFormType,
            isFormDataDirty: initialFormType !== nextFormType,
            isFromBallot
        }));
    }

    handleBallotPortalRedirect() {
        const { state: { ssoConfig: { ballotRedirectUrl } } } = app;

        if (!hasValue(ballotRedirectUrl)) {
            reloadPageWithoutQueryParams();
        }

        redirectTo(ballotRedirectUrl);
    }

    handleBallotSignIn() {
        this.setState((state) => ({
            ...state,
            ssoFormType: ssoFormTypes.BallotSignInForm,
            isFormDataDirty: false
        }));
    }

    handleNewPasswordRequired(cognitoUser) {
        this.setState((state) => ({
            ...state,
            ssoFormType: ssoFormTypes.NewPasswordRequired,
            cognitoUser
        }));
    }

    handleSignInSucces(formData, formType = ssoFormTypes.SignInSuccess) {
        formData = hasValue(formData) ? { ...formData, hideCloseButton: true, reloadPage: true } : formData;

        this.setState((state) => ({
            ...state,
            ssoFormType: formType,
            formData
        }));
    }

    getTransitionToForm() {
        const { registerFormType, initialFormType } = this.state;

        if (registerFormType >= 0) {
            return registerFormType;
        }

        const { ssoDomain, nextFormTypeAfterRegister } = this.props.formData;
        const formForTransitionTo = ssoDomain === domainConstants.womensOpen ?
            ssoFormTypes.TicketingRegister :
            ssoFormTypes.OneClubRegister;

        return initialFormType === ssoFormTypes.SignIn || initialFormType === ssoFormTypes.PreRegisterForm ?
            (hasValue(nextFormTypeAfterRegister) ? nextFormTypeAfterRegister : formForTransitionTo) :
            initialFormType;
    }

    handleUserRegisterSuccess(emailAddress, {
        isBallotRegister,
        successText,
        emailVerificationCallbackUrl,
        emailVerificationActionSuccessText,
        displayBanner,
        bannerBackgroundImageSrc,
        bannerSuccessRegistration
    }) {
        const {
            requestEmailVerificationCallbackUrl,
            actionSuccessText,
            requestEmailVerificationActionSuccessText
        } = this.props.formData;

        this.setState((state) => ({
            ...state,
            ssoFormType: ssoFormTypes.OneClubRegisterSuccess,
            emailAddress,
            requestEmailVerificationCallbackUrl: requestEmailVerificationCallbackUrl || emailVerificationCallbackUrl,
            actionSuccessText: successText || actionSuccessText,
            requestEmailVerificationActionSuccessText: requestEmailVerificationActionSuccessText || emailVerificationActionSuccessText,
            displayBanner,
            isBallotRegister,
            bannerBackgroundImageSrc,
            bannerSuccessRegistration
        }));
    }

    handleForgotPassword() {
        this.setState((state) => ({
            ...state,
            ssoFormType: ssoFormTypes.ForgotPassword
        }));
    }

    handleBallotForgotPassword() {
        this.setState((state) => ({
            ...state,
            ssoFormType: ssoFormTypes.BallotForgotPassword
        }));
    }

    handleSignIn() {
        this.setState((state) => ({
            ...state,
            ssoFormType: ssoFormTypes.SignIn
        }));
    }

    handleCognitoHostedUISignIn(returnUrl = '') {
        if (!hasValue(returnUrl) || this.isFromButtonEvent(returnUrl)) {
            returnUrl = window.location.href;
        }

        userService.onSignInLinkClickAction(returnUrl, true);
    }

    isFromButtonEvent(returnUrl) {
        return returnUrl.hasOwnProperty('type');
    }

    displaySSOForm() {
        const {
            ssoFormType,
            isFromBallot,
            emailAddress,
            isFormDataDirty,
            requestEmailVerificationCallbackUrl,
            actionSuccessText,
            requestEmailVerificationActionSuccessText,
            displayBanner,
            isBallotRegister,
            cognitoUser,
            bannerBackgroundImageSrc,
            bannerSuccessRegistration
        } = this.state;

        const { formData } = hasValue(this.state.formData) ? this.state : this.props;
        const { ssoDomain } = formData;

        const copyOfFormData = cloneDeep(formData);
        const { nextFormAfterSubmit } = copyOfFormData;

        return ssoFormConstants[ssoFormType]({
            formData: isFormDataDirty ? {} : copyOfFormData,
            emailAddress,
            ssoDomain,
            requestEmailVerificationCallbackUrl,
            actionSuccessText,
            requestEmailVerificationActionSuccessText,
            displayBanner,
            isBallotRegister,
            cognitoUser,
            ssoFormType,
            bannerBackgroundImageSrc,
            bannerSuccessRegistration,
            isFromBallot: isFromBallot || copyOfFormData.isFromBallot,
            formId: nextFormAfterSubmit,
            handleRegister: this.handleRegister,
            handleUserRegisterSuccess: this.handleUserRegisterSuccess,
            handleSignIn: this.handleSignIn,
            handleCognitoHostedUISignIn: this.handleCognitoHostedUISignIn,
            handleForgotPassword: this.handleForgotPassword,
            handleSignInSucces: this.handleSignInSucces,
            handleNewPasswordRequired: this.handleNewPasswordRequired,
            handleBallotSignIn: this.handleBallotSignIn,
            handleBallotRegister: this.handleBallotRegister,
            handleBallotForgotPassword: this.handleBallotForgotPassword,
            handleBallotSummarySuccess: this.handleBallotSummarySuccess,
            handleBallotPortalRedirect: this.handleBallotPortalRedirect,
        });
    }

    render() {
        const { modalOpen } = this.state;
        const { IsPopup } = this.props;
        const shouldDisplayForm = IsPopup ? modalOpen : true;
        return (
            <SSOFormContext.Provider value={this.ssoContext}>
                {shouldDisplayForm ? this.displaySSOForm() : null}
            </SSOFormContext.Provider>
        );
    }
}

SSOForm.propTypes = {
    formData: PropTypes.object.isRequired
};

export default SSOForm;
